/* eslint-disable eqeqeq */  

import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { CommonPageData } from '../../../styles/common.style';
import { SocketContext } from "../../App"; // Import SocketContext

const ProgramList = () => {
  const [userData, setUserData] = useState(null);
  const socket = useContext(SocketContext); // Access the socket instance

  useEffect(() => {
    // TODO: Remove this line
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserData(parsedUser);
    }
  }, []);

  useEffect(() => {
    if (socket) {
      // Listen for program updates
      socket.on("programDaysUpdated", (response) => {
        
        if (response?.userActivePrograms) {
          setUserData((prevData) => ({
            ...prevData,
            userActivePrograms: response.userActivePrograms,
          }));
        }
      });

      // Cleanup listener on unmount
      return () => {
        socket.off("programDaysUpdated");
      };
    }
  }, [socket]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (socket) {
        socket.emit("requestProgramUpdate", { userId: userData?.id }, (response) => {
          if (response?.userActivePrograms) {
            setUserData((prevData) => ({
              ...prevData,
              userActivePrograms: response.userActivePrograms,
            }));
          }
        });
      }
    }, 10000); // every 10 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [socket, userData]);

  return (
    <>
      <Header />
      <CommonPageData>
        <div className='common-banner-block'>
          <div className='main-banner'>
            <img src='/images/banner-common-block.png' alt='img' />
          </div>
          <div className='container'>
            <div className='common-banner-block-inner'>
              <h1>Programs</h1>
            </div>
          </div>
        </div>
        <section className='assestmentd1_001 program-box-height common-padding-block'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 col-lg-12 col-md-12 text-center'>
                <h2 className='title-inner-block'>My Programs</h2>
                <>
                  <div className='programs'>
                    {userData?.userActivePrograms?.length > 0 ? (
                      userData.userActivePrograms.map(
                        (data, key) =>
                          data && (
                            <div key={key} className={`program-card ${data?.is_default == 1 ? 'active' : ''}`}>
                              <Link to={`/program/${data?.program_id}`}>{data?.program?.name}</Link>
                            </div>
                          )
                      )
                    ) : (
                      <p>No active programs available.</p>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        </section>
      </CommonPageData>
      <Footer />
    </>
  );
};

export default ProgramList;
